import React, { FC, useEffect } from 'react'
import { useCustomerAuth } from '../auth/CustomerAuthContext'
import ProfileInformation from './ProfileInformation'

import { ProfileWallet } from './ProfileWallet'
import styles from './account.module.css'
import { ProfileAddresses } from './ProfileAddresses'
import { t } from '@local/translations'

const Account: FC = () => {
  const { customer, refetchCustomer } = useCustomerAuth()

  // refetch the customer to get the latest data
  useEffect(() => {
    refetchCustomer()
  }, [refetchCustomer])

  if (!customer) {
    return <>{t('account.not-found-message')}</>
  }

  return (
    <div data-testid='Account' className={'text-default mb-4'}>
      <ProfileInformation />

      <div className={styles.sectionSeparatorWrapper}>
        <hr className={styles.sectionSeparator} />
      </div>

      <ProfileAddresses />

      <div className={styles.sectionSeparatorWrapper}>
        <hr className={styles.sectionSeparator} />
      </div>

      <ProfileWallet />
    </div>
  )
}

export default Account
